'use strict';

// Constructor
var Slide1 = function () {
    $('.slide1').waypoint(function () {
        $('.slider button').removeClass('active');
        $('.slider .button_slide1').addClass('active');
        $('.slide1 .leaf').addClass('active');
        
    }, {
        offset: '0%'
    });        
};

module.exports = Slide1;
